/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react'
import Head from 'next/head'

const VideoAd = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {
        console.error('Adsense error:', e)
      }
    }
  }, [])

  return (
    <>
      <Head>
        {/* Use Google's test client ID */}
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4135737503770736"
          crossOrigin="anonymous"
        ></script>
      </Head>

      {/* Use Google's test ad slot ID */}
      <div style={{ width: '100%', height: '280px', minWidth: '300px' }}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-4135737503770736"
          data-ad-slot="7314097563"
          data-ad-format="auto"
          data-full-width-responsive="true"
          data-adtest="on" // Not necessary with test IDs
        ></ins>
      </div>
    </>
  )
}

export default VideoAd
